import {css} from 'lit';
export const styles = css`:host {
  --dot-menu-trigger-width: 32px;
  --dot-menu-trigger-height: 22px;
  --dot-menu-trigger-radius: 4px;
  --dot-menu-trigger-border: 1px solid var(--border-light);
}
`;
export default styles;
